import type { RealestateAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { calculateOwnership } from "../genericCalculations/ownership";
import { calculateRealestateDestinationStateCurrency } from "./destinationState";
import { calculateRealestateOriginStateCurrency } from "./originState";
import { calculateRentYearly } from "./rent";
import { calculateRealestateYearlySum } from "./yearlySum";
import { convertCurrency } from "../genericCalculations/convertCurrency";

export const calculateRealestateNetMonthlyCashflowWithTax = (
  userProduct: RealestateAsset,
  baseCurrency: Fiat,
  currentCurrency: Fiat
) => {
  const ownership = userProduct?.ownership || 0;

  const yearlySum = calculateRealestateYearlySum(
    userProduct,
    baseCurrency,
    currentCurrency
  );

  const totalIncome = calculateRentYearly(userProduct);

  const originStateTax = calculateRealestateOriginStateCurrency(
    userProduct,
    baseCurrency,
    currentCurrency
  );

  const destinationStateTax = calculateRealestateDestinationStateCurrency(
    userProduct,
    baseCurrency,
    currentCurrency
  );

  const netYearlyFlow =
    totalIncome - (yearlySum + originStateTax + destinationStateTax);

  const netMonthlyFlow = netYearlyFlow / 12;
  const netMonthlyFlowBaseCurrency = convertCurrency(netMonthlyFlow, baseCurrency, currentCurrency);
  return calculateOwnership(netMonthlyFlowBaseCurrency, ownership);
};
